export const usePrice = ({
  value,
  variant = 'default',
  size = 'm',
  color = 'text-primary',
  fraction = false
}) => {
  const localeOptions = {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2
  };
  const isValidValue = typeof value === 'number';
  const stringValue = isValidValue ? value.toLocaleString('ru-RU', localeOptions).replace(/-/g, '\u2212') : '—';
  const [integer, decimals] = stringValue.split(',');
  return {
    integer,
    decimals,
    // FIXME: Удалить fraction когда все будут использовать правильный value. Также удалить fraction из аргументов компонента во всем коде.
    showFraction: fraction && !!decimals,
    integerProps: {
      color,
      ...integerSizeMap[variant][size]
    },
    fractionProps: {
      color,
      ...fractionSizeMap[variant][size]
    },
    prefixProps: {
      color,
      ...unitsSizeMapping[variant][size]
    },
    unitsProps: {
      color,
      ...unitsSizeMapping[variant][size]
    }
  };
};
const defaultSizeMapping = {
  xxs: {
    variant: 'mini',
    size: 'regular'
  },
  xs: {
    variant: 'minor',
    size: 'caption'
  },
  s: {
    variant: 's',
    size: 'body_long'
  },
  m: {
    variant: 'm',
    size: 'body_long'
  },
  l: {
    variant: 'l',
    size: 'body_long'
  }
};
const accentSizeMapping = {
  xxs: {
    variant: 'mini',
    size: 'accent'
  },
  xs: {
    variant: 'minor',
    size: 'caption_accent'
  },
  s: {
    variant: 's',
    size: 'overline'
  },
  m: {
    variant: 'm',
    size: 'overline'
  },
  l: {
    variant: 'l',
    size: 'overline'
  },
  xl: {
    variant: 'h2',
    size: 'extra'
  }
};
const integerSizeMap = {
  default: defaultSizeMapping,
  accent: accentSizeMapping,
  // Deprecated варианты для совместимости
  // FIXME: Удалить regular и medium когда все будут использовать default и accent
  regular: defaultSizeMapping,
  medium: accentSizeMapping
};
const defaultFractionMapping = {
  xxs: {
    variant: 'mini',
    size: 'regular'
  },
  xs: {
    variant: 'minor',
    size: 'caption'
  },
  s: {
    variant: 'minor',
    size: 'caption'
  },
  m: {
    variant: 'minor',
    size: 'caption'
  },
  l: {
    variant: 's',
    size: 'body_long'
  }
};
const accentFractionMapping = {
  xxs: {
    variant: 'mini',
    size: 'accent'
  },
  xs: {
    variant: 'minor',
    size: 'caption_accent'
  },
  s: {
    variant: 'minor',
    size: 'overline'
  },
  m: {
    variant: 'minor',
    size: 'overline'
  },
  l: {
    variant: 's',
    size: 'overline'
  },
  xl: {
    variant: 'm',
    size: 'overline'
  }
};
const fractionSizeMap = {
  default: defaultFractionMapping,
  accent: accentFractionMapping,
  // Deprecated варианты для совместимости
  // FIXME: Удалить regular и medium когда все будут использовать default и accent
  regular: defaultFractionMapping,
  medium: accentFractionMapping
};
const accentUnitsSizeMapping = {
  xxs: {
    variant: 'mini',
    size: 'accent'
  },
  xs: {
    variant: 'minor',
    size: 'caption_accent'
  },
  s: {
    variant: 'minor',
    size: 'caption_accent'
  },
  m: {
    variant: 'minor',
    size: 'caption_accent'
  },
  l: {
    variant: 's',
    size: 'body_accent'
  },
  xl: {
    variant: 'm',
    size: 'body_accent'
  }
};
const unitsSizeMapping = {
  default: defaultFractionMapping,
  accent: accentUnitsSizeMapping,
  // Deprecated варианты для совместимости
  // FIXME: Удалить regular и medium когда все будут использовать default и accent
  regular: defaultFractionMapping,
  medium: accentUnitsSizeMapping
};